import { CalendarForm } from "./calendars.types";

export const INITIAL_START_TIME = "08:00";
export const INITIAL_END_TIME = "16:00";
export const WORKDAY_MINUTES = 480;

export const DEFAULT_CALENDAR_FORM_DAYS: Omit<CalendarForm, "name"> = {
  nominalDays: [
    {
      dayName: "monday",
      startTime: INITIAL_START_TIME,
      endTime: INITIAL_END_TIME,
      workingMinutes: 480
    },
    {
      dayName: "tuesday",
      startTime: INITIAL_START_TIME,
      endTime: INITIAL_END_TIME,
      workingMinutes: 480
    },

    {
      dayName: "wednesday",
      startTime: INITIAL_START_TIME,
      endTime: INITIAL_END_TIME,
      workingMinutes: 480
    },
    {
      dayName: "thursday",
      startTime: INITIAL_START_TIME,
      endTime: INITIAL_END_TIME,
      workingMinutes: 480
    },
    {
      dayName: "friday",
      startTime: INITIAL_START_TIME,
      endTime: INITIAL_END_TIME,
      workingMinutes: 480
    },
    {
      dayName: "saturday",
      startTime: null,
      endTime: null,
      workingMinutes: 0
    },
    {
      dayName: "sunday",
      startTime: null,
      endTime: null,
      workingMinutes: 0
    }
  ],
  exceptionDays: []
};
